import hdrm from '../hdrm';

const createScript = (documentNode, src) => {
  const script = documentNode.createElement('script');

  script.src = src;

  hdrm.injections.bindings.mutation.ignore(script);

  return script;
};

export default createScript;
